module.exports = __webpack_public_path__ + "static/media/avatar_2.1e954293.png";